import { Box } from '@creditas-ui/layout';
import { InputPin } from '@creditas-ui/input';
import { Typography } from '@creditas-ui/typography';
import { styled } from '@creditas-ui/system';
import { StepLayout } from '../../../components/StepLayout';
import { useWizard } from '../../../components/StepWizard';
import { ResendAccessCode } from './ResendAccessCode/ResendAccessCode';
import { useAccessCodeStep } from './useAccessCodeStep';
import i18n from '../../../i18n';
import { AccessCodeStepProps } from './types';

const Title = styled(Typography)`
  white-space: pre-wrap;
`;

const AccessCodeStep = ({ flowType }: AccessCodeStepProps): JSX.Element => {
  const { hasPrev } = useWizard();
  const {
    claim,
    accessCode,
    errorMessage,
    isValid,
    isLoading,
    handleInputChange,
    handleBackButtonClick,
    handleSubmit,
    handleResendLinkClick,
  } = useAccessCodeStep(flowType);

  return (
    <StepLayout
      isValid={isValid}
      isLoading={isLoading}
      showBack={hasPrev}
      helperText={<ResendAccessCode onActionLinkClick={handleResendLinkClick} />}
      handleBack={handleBackButtonClick}
      handleSubmit={handleSubmit}
    >
      <Box marginBottom={{ _: '44px', '5xl': '80px' }}>
        <Title color="neutral.90" variant={{ _: 'bodyLgRegular', '5xl': 'headingSmRegular' }}>
          {i18n.t('flows:shared.access_code_step.title', { claim })}
        </Title>
      </Box>

      <form onSubmit={handleSubmit}>
        <InputPin
          data-testid="access-code"
          value={accessCode}
          // TODO: the following props should be typed correctly (or even shouldn't be here). We are using this temporarily to fix the onPaste behavior.
          onChange={handleInputChange}
          onComplete={handleInputChange}
          onSubmit={() => {
            handleSubmit();
          }}
        />
      </form>

      {errorMessage && (
        <Typography color="error.60" variant={{ _: 'bodySmRegular', '5xl': 'bodyMdRegular' }}>
          {errorMessage}
        </Typography>
      )}
    </StepLayout>
  );
};

export { AccessCodeStep };
